import { ReactNode } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import s from "./ScopeStrip.module.scss";

/** The "Applies to N contacts ..." strip at the top of a bulk dialog. Content comes in as children. */
export const ScopeStrip = ({ children }: { children: ReactNode }) => (
  <div className={s.strip}>
    <InfoOutlinedIcon aria-hidden="true" className={s.icon} />
    <span>{children}</span>
  </div>
);
